// JQUERY

// APP JS (Drupal)

$ = jQuery;
// A
// Setting FOCUS into Browser Window
$(window).focus();

// B:
// DOM Ready : init function
//
$(document).ready(function () {

  // Fix for accessibility
  fn_a11y_modal_config(); // Esloquant is BS4
  fn_a11y_form_size();
  fn_a11y_focus_tabindex();

  // Main stuff
  body_nav_pad();
  fn_header_sticky();
  //
  fn_nav_megamenu();
  fn_nav_subheadermenu();
  fn_nav_accountmenu();
  fn_search_global();
  //
  fn_cover();
  fn_print();
  fn_float_label();
  fn_input_autocomplete();
  fn_access_inputs();
  fn_role_button();
  //
  fn_stickybits();
  fn_popover_init();
  fn_responsive_table();

  fn_masthead_node_scroll();
  fn_reveal_scroll();
  height_equalizer();

  fn_tooltip_init();

  //
  // OLD FN from v1
  //
  fn_modal_bs();
  //
  fn_scroll_top();
  fn_scroll_to();
  //
  fn_img_random();
  fn_accordion_fx();
  fn_nav_page();
  fn_aside();
  fn_sharingtools_fixed();
  fn_dashboard();
  fn_search_sort();
  see_more_dossier();
  fn_masthead_scroll();
  fn_navanchor_spy();

  fn_list_collapsable();

  fn_data_animate();
  fn_event_bookingbar();

  fn_modal_topic_bs();

  initCarouselHlSegment();
  initSplideCarouselRwd();
  initSplideCarousel();

  // Unknown
  $('.jvectormap-container').before($('.jvectormap-tip'));

// //
});

$(document).ajaxComplete(function (event, request, settings) {
  // modal();
  fn_float_label();
  fn_input_autocomplete();

});
